'use strict';

exports.__esModule = true;
var navigate = exports.navigate = {
  PREVIOUS: 'PREV',
  NEXT: 'NEXT',
  TODAY: 'TODAY',
  DATE: 'DATE'
};

var views = exports.views = {
  MONTH: 'month',
  WEEK: 'week',
  WORK_WEEK: 'work_week',
  DAY: 'day',
  AGENDA: 'agenda'
};


//////////////////
// WEBPACK FOOTER
// ./~/react-big-calendar/lib/utils/constants.js
// module id = 120
// module chunks = 0